import request from '@/utils/request'
import { parseTime } from '@/utils/index'
// 添加导出任务
export function addExportTask(data, fileName) {
  // const title = document.title.replace(/ - 数据中心|- 发行中心/g, '') || ''
  const title = document.title || ''
  const date = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')
  data.download_filename = fileName || title + '报表-' + date
  return request({
    url: '/common/addExportTask',
    method: 'post',
    data
  })
}

// 导出任务列表
export function exportFileList(data) {
  return request({
    url: '/common/searchExportFileList',
    method: 'post',
    data
  })
}

// 导出检测频次
export function checkExportTaskFrequency(data) {
  return request({
    url: '/common/checkExportTaskFrequency',
    method: 'post',
    data
  })
}

// 根游戏列表(级联平台)
export function rootGameListByPlatform(data) {
  return request({
    url: '/common/rootGameListByPlatform',
    method: 'post',
    data
  })
}

// 游戏列表(级联平台)
export function gameListByPlatform(data) {
  return request({
    url: '/common/gameListByPlatform',
    method: 'post',
    data
  })
}

// 主游戏列表(级联根游戏) 运营利润
export function mainGameListByRootGame(data) {
  return request({
    url: '/common/mainGameListByRootGame',
    method: 'post',
    data
  })
}

// 获取平台列表(预警标准)
export function getAllPlatform() {
  return request({
    url: '/common/allPlatform',
    method: 'post'
  })
}

// 获取主游戏（级联平台）(预警标准)
export function getMainGameListByPlatform(data) {
  return request({
    url: '/common/mainGameListByPlatform',
    method: 'post',
    data
  })
}

// 获取路由维度权限
export function getAllRoutePermission(data) {
  return request({
    url: '/common/getAllRoutePermission',
    method: 'post',
    data
  })
}

// 获取全部路由列表
export function gatAllRouterCascader(data) {
  return request({
    url: '/common/allRouterCascader',
    method: 'post',
    data: data
  })
}

export function reportError(data) {
  return request({
    url: '/common/reportError',
    method: 'post',
    data: data
  })
}

export function lyMainGameListByRootGame(params) {
  return request({
    url: '/common/lyMainGameListByRootGame',
    method: 'get',
    params
  })
}

export function dmsPlatform() {
  return request({
    url: '/common/dmsPlatform',
    method: 'get'
  })
}

export function getAgentListByPlatform(data) {
  return request({
    url: '/common/getAgentListByPlatform',
    method: 'post',
    data
  })
}

export function allPermissionDetail(level, id) {
  return request({
    url: 'common/getOuterAllPermissionDetail',
    method: 'get'
  }).then(response => {
    const platformOptions = response.data.platform_list
    const routePermissionList = response.data.route_permission_list
    const permissionCascader = response.data.route_cascader.map(father => {
      const children = father.children.map(children => {
        children['children'] = []
        for (const i in routePermissionList) {
          if (routePermissionList[i].route_id === children.id) {
            let cateIndex = children['children'].findIndex(element => element.label === routePermissionList[i].cate_name)
            if (cateIndex === -1) {
              children['children'].push({
                id: children.id,
                value: routePermissionList[i].cate_name,
                label: routePermissionList[i].cate_name,
                children: []
              })
              cateIndex = children['children'].length - 1
            }
            if (routePermissionList[i]['type']) {
              let permissionIndex = children['children'][cateIndex]['children'].findIndex(element => element.label === routePermissionList[i].type)
              if (permissionIndex === -1) {
                children['children'][cateIndex]['children'].push({
                  value: routePermissionList[i].type,
                  label: routePermissionList[i].type,
                  children: []
                })
                permissionIndex = children['children'][cateIndex]['children'].length - 1
              }
              children['children'][cateIndex]['children'][permissionIndex]['children'].push({
                id: routePermissionList[i].id,
                value: routePermissionList[i].id,
                label: routePermissionList[i].name
              })
            } else {
              children['children'][cateIndex]['children'].push({
                id: routePermissionList[i].id,
                value: routePermissionList[i].id,
                label: routePermissionList[i].name
              })
            }
          }
        }
        if (children['children'].length === 0) delete children['children']
        return children
      })

      father.children = children
      return father
    })
    return {
      data: { platform_options: platformOptions, permission_cascader: permissionCascader, route_permission_list: routePermissionList }
    }
  })
}

export function addAgencyPermission(data) {
  return request({
    url: '/common/addAgencyUserPermission',
    method: 'post',
    data
  })
}
